module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f31e.522c8314.svg";